import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import ImageUploading from "react-images-uploading";


import { uploadBulkShortVideoApi } from "../../store/shortVideo/bulkShortVideo";
import { shortVideoApi } from "../../store/shortVideo/shortVideoList";
import { uploadBulkQuizApi } from "../../store/quizzes/bulkQuiz";
import { quizListApi } from "../../store/quizzes/quizList";

export default function BulkQuiz({ open, setOpen, id }) {
  const bulkQuiz = useSelector((state) => state?.bulkQuiz);
  const { result, loading } = bulkQuiz;
  const [selectedFile, setSelectedFile] = useState(null);
 

  const [uploadProgress, setUploadProgress] = useState(null);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  const uploadConfirm = async () => {
    // console.log("data", selectedFile);
    let formData = new FormData();
    formData.append("file", selectedFile);
    await dispatch(uploadBulkQuizApi(formData));

    if (!bulkQuiz?.loading) {
      dispatch(quizListApi());
      setOpen(false);
      setSelectedFile(null);
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ width: "30%" }}>
          <Stack alignItems="flex-end">
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
          </Stack>
          <Stack alignItems="center" my={2}>
            <Typography variant="h5" fontWeight={600}>
              Please Select a file to upload ?
            </Typography>
          </Stack>
          <Stack alignItems="center" my={2}>
            {selectedFile ? (
              <Typography variant="h5" fontWeight={600}>
                {selectedFile.name}
                <IconButton onClick={() => setSelectedFile(null)}>
                  <ClearIcon />
                </IconButton>
              </Typography>
            ) : (
              <>
                <input
                  accept=".csv,.xlxs,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style={{ display: "none" }}
                  id="raised-button-file"
                  type="file"
                  ref={ref}
                  onChange={(e) => setSelectedFile(e.target?.files[0])}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => ref.current.click()}
                >
                  Upload File
                </Button>
              </>
            )}
            {loading ? (
              <Box sx={{ width: "60%" }}>
                <LinearProgress />
              </Box>
            ) : null}
          </Stack>

          <Stack sx={{ mt: 2 }} justifyContent="center" direction="row">
            <Button
              variant="outlined"
              onClick={() => handleClose()}
              sx={{ mr: 2 }}
            >
              Back
            </Button>
            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                onClick={() => uploadConfirm()}
                disabled={!selectedFile ? true : false}
              >
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}

BulkQuiz.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  id: PropTypes.any,
};
